
import Vue from "vue";

import {
  getHazratMassomehData,
  getImamHussainData,
} from "@/core/functions/localstorage-data";
import {HolyShrineType} from "@/enums/holy-shrine-type";

export default Vue.extend({
  name: "inquiry",

  components: {},
  data() {
    return {
      data: [],
      type: ""
    };
  },
  mounted() {
    this.type = this.$route.params.type;
    if (this.type == HolyShrineType.ImamHussain) {
      this.data = getImamHussainData();
    } else if (this.type == HolyShrineType.HazratMassomeh) {
      this.data = getHazratMassomehData();
    }
  },
  methods: {
    handleDetails(phoneNumber) {
      this.$router.push({
        name: "inquiry-details",
        params: {type: this.type, id: phoneNumber},
      });
    },
    handleInquiry() {
      this.$store.commit("setconfigInquiryRegister", {
        isOpen: true,
        imamHussainZiarat: this.type == HolyShrineType.ImamHussain,
        hazratMassomehZiarat: this.type != HolyShrineType.ImamHussain,
      });
    },
  },
});
